export default __webpack_public_path__ + "static/media/radiant-bright-red.4e96d968.jpg";